export function routeRequest(year, weekSlug) {
  if (year == null && weekSlug == null) return null;
  const season = Number(year);
  const match = /^week-(\d+)$/i.exec(weekSlug || '');
  const week = match ? Number(match[1]) : null;
  return Number.isInteger(season) && Number.isInteger(week) && week >= 1 && week <= 18 ? { season, week } : { invalid: true };
}

export function resolveIssue(manifest, request) {
  if (request?.invalid) return null;
  const target = request || manifest.latest;
  return manifest.issues.find((issue) => issue.season === target.season && issue.week === target.week) || null;
}

export async function loadPredictionIssue(issue, signal) {
  const response = await fetch(issue.path, { signal, headers: { Accept: 'application/json' } });
  const type = response.headers.get('content-type') || '';
  if (!response.ok || !type.includes('application/json')) throw new Error('The published issue could not be read.');
  const prediction = await response.json();
  if (!prediction || prediction.season !== issue.season || prediction.week !== issue.week || !Array.isArray(prediction.teams) || prediction.teams.length !== 10 || !prediction.teams.every((team) => typeof team.manager === 'string' && Number.isFinite(team.score) && Array.isArray(team.players) && team.players.length === 11 && team.players.every((player) => typeof player.slot === 'string' && typeof player.name === 'string' && Number.isFinite(player.score))) || !Array.isArray(prediction.matchups) || prediction.matchups.length !== 5 || !prediction.methodology || !Array.isArray(prediction.methodology.rules) || !Array.isArray(prediction.methodology.limits)) throw new Error('The published issue did not match the requested week.');
  return prediction;
}
